import {
  Component,
  ContentChild,
  AfterContentInit,
  TemplateRef,
  Input,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';

@Component({
    selector: 'pme-carousel-swiper-consulta',
    templateUrl: './carousel-swiper-consulta.component.html',
    styleUrls: ['./carousel-swiper-consulta.component.scss'],
    standalone: false
})
export class CarouselSwiperConsultaComponent implements AfterContentInit, AfterViewInit, OnDestroy {
  @Input() identifier!: string;
  @Input() items: any[] = [];
  @ContentChild(TemplateRef) slideTemplate!: TemplateRef<any>;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('discountBadge') discountBadge!: ElementRef;

  discountBadgeHeight!: number;
  hasOverflow = false;
  isAtStart = true;
  isAtEnd = false;
  private resizeObserver!: ResizeObserver;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterContentInit() {}

  ngAfterViewInit() {
    requestAnimationFrame(() => this.syncHeights());
    this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
    this.resizeObserver.observe(this.scrollContainer.nativeElement);
    this.checkOverflow();
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }

  public update() {
    this.syncHeights();
    this.checkOverflow();
  }

  private checkOverflow() {
    const el = this.scrollContainer?.nativeElement;
    if (el) {
      this.hasOverflow = el.scrollWidth > el.clientWidth;
      this.checkScrollPosition();
      this.cdr.markForCheck();
    }
  }

  private checkScrollPosition() {
    const el = this.scrollContainer?.nativeElement;
    if (el) {
      this.isAtStart = el.scrollLeft <= 0;
      this.isAtEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
      this.cdr.markForCheck();
    }
  }

  onScroll() {
    this.checkScrollPosition();
  }

  scrollPrev() {
    this.scrollContainer?.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollNext() {
    this.scrollContainer?.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
  }

  syncHeights() {
    if (this.discountBadge) {
      const height = this.discountBadge.nativeElement.offsetHeight;
      this.discountBadgeHeight = height;
    }
  }
}
